import {
  GroupedMedicalDocuments,
  MedicalDocument,
  MedicalDocumentType,
  prescriptionDocumentTypes,
  uploadableDocumentTypes
} from '../model';
import { MedicalDocumentService } from '../medicalDocument.service';
import { patientBffApi } from '@/modules/baseApi';
import { wrapError } from '@/util';
import { setUploadProgress } from '@/modules/ui';

const medicalDocumentApi = patientBffApi.injectEndpoints({
  endpoints: (builder) => ({
    medicalDocuments: builder.query<GroupedMedicalDocuments, void>({
      queryFn: () =>
        MedicalDocumentService.getInstance()
          .fetchGroupedByType({
            types: [
              ...uploadableDocumentTypes,
              MedicalDocumentType.CONSENT_FORM
            ]
          })
          .then((data) => ({ data }))
          .catch(wrapError),
      providesTags: ['MedicalDocument']
    }),

    prescriptionDocuments: builder.query<GroupedMedicalDocuments, void>({
      queryFn: () =>
        MedicalDocumentService.getInstance()
          .fetchGroupedByType({
            types: prescriptionDocumentTypes as unknown as string[]
          })
          .then((data) => ({ data }))
          .catch(wrapError),
      providesTags: ['PrescriptionDocument']
    }),

    upsertMedicalDocument: builder.mutation<
      MedicalDocument[],
      {
        document: Partial<MedicalDocument>;
        newFiles?: File[];
      }
    >({
      queryFn: ({ document, newFiles }, { dispatch }) => {
        const onProgress = ({ loaded, total }: ProgressEvent) => {
          dispatch(setUploadProgress(loaded / total));
        };

        return MedicalDocumentService.getInstance()
          .upload(document, newFiles, onProgress)
          .catch(wrapError)
          .finally(() => {
            dispatch(setUploadProgress(undefined));
          });
      },
      invalidatesTags: ['MedicalDocument', 'PrescriptionDocument']
    })
  }),
  overrideExisting: false
});

export const {
  useMedicalDocumentsQuery: useMedicalDocuments,
  usePrescriptionDocumentsQuery: usePrescriptions,
  useUpsertMedicalDocumentMutation: useUpsertMedicalDocument
} = medicalDocumentApi;
